Vue.component('widget-angle-down-up', require('../src/components/Widgets/AngleDownUp').default);

Vue.component('fixed-header', require('../src/components/Header/FixedHeader').default);
Vue.component('navigation-handler', require('../src/components/Navigation/FrontNavigationHandler').default);
Vue.component('navigation', require('../src/components/Navigation/Navigation').default);
Vue.component('select-paginator', require('../src/components/Paginator/Select').default);

/**
 * Image
 */
Vue.component('image-tag', require('../src/components/Tag/Image').default);
Vue.component('slide-show', require('../src/components/SlideShow/Wrapper').default);
Vue.component('gallery-image-grid', require('../src/components/Gallery/ImageGrid').default);

/**
 * Utilities
 */
Vue.component('on-off-switch', require('../src/components/Triggers/OnOffSwitch').default);
Vue.component('remove-dialog-button', require('../src/components/Triggers/RemoveDialogButton').default);
Vue.component('call-redirect', require('../src/components/Triggers/CallRedirect').default);
Vue.component('call-reload', require('../src/components/Triggers/CallReload').default);
Vue.component('call-dialog-confirm', require('../src/components/Triggers/CallDialogConfirm').default);
Vue.component('click-fire-event', require('../src/components/Triggers/ClickFireEvent').default);
Vue.component('top-dialog', require('../src/components/Dialogs/TopDialog').default);

Vue.component('modal-wrapper', require('../src/components/Modal/Wrapper').default);

/**
 * Search
 */
// Vue.component('instant-search', require('../src/components/Search/AlgoliaSearch').default);
Vue.component('search-collection', require('../src/components/Search/SearchCollection').default);
// Vue.component('search-button', require('../src/components/Search/SearchButton').default);

/**
 * Form
 */
Vue.component('form-button', require('../src/components/Form/FormButton').default);
Vue.component('trigger-button', require('../src/components/Form/TriggerButton').default);
Vue.component('form-wrapper', require('../src/components/Form/FormWrapper').default);
Vue.component('select-redirect', require('../src/components/Form/SelectRedirect').default);

Vue.component('text-input', require('../src/components/Form/Inputs/TextInput').default);
Vue.component('text-input-with-button', require('../src/components/Form/Inputs/TextInputWithButton').default);
Vue.component('hidden-input', require('../src/components/Form/Inputs/HiddenInput').default);
Vue.component('email-input', require('../src/components/Form/Inputs/EmailInput').default);
Vue.component('password-input', require('../src/components/Form/Inputs/PasswordInput').default);
Vue.component('checkbox-input', require('../src/components/Form/Inputs/CheckBoxInput').default);
Vue.component('text-area', require('../src/components/Form/Inputs/TextArea').default);
Vue.component('multi-select-group', require('../src/components/Form/Inputs/MultiSelectGroup').default);

Vue.component('single-select', require('../src/components/Form/Inputs/SingleSelect').default);

Vue.component('multi-page-form', require('../src/components/Form/MultiPage').default);
Vue.component('dependable-wrapper', require('../src/components/Form/DependableWrapper').default);

Vue.component('switch-input', require('../src/components/Form/Inputs/Switch').default);

/**
 * Widgets
 */
Vue.component('cross-reference', require('../src/components/Widgets/CrossReference').default);
Vue.component('feed-wrapper', require('../src/components/Widgets/FeedWrapper').default);
Vue.component('fetch-data', require('../src/components/FetchData').default);
Vue.component('cookie-dialog', require('../src/components/Cookie/CookieDialog').default);
Vue.component('cookie-setup', require('../src/components/Cookie/CookieSetup').default);

Vue.component('grid', require('../src/components/Grid/Grid').default);
Vue.component('accordion', require('../src/components/Reveal/Accordion').default);

Vue.component('captcha', require('../src/components/Captcha').default);

Vue.component('booking-dates', require('../src/components/Booking/Dates').default);
Vue.component('booking-search-result', require('../src/components/Booking/SearchResult').default);
Vue.component('stripe-button', require('../src/components/Billing/StripeButton').default);
Vue.component('product-select', require('../src/components/Billing/ProductSelect').default);